import exodusInstance from 'lib/api/instances/exodus';
import { APIResponse } from '../../../../@types/api-response';
import orderEndpoints from '../constants/apiEndpoints/order';
import {
  VirtualTradingOrder,
  VirtualCreateOrderPayload,
  VirtualAmendOrderResponse,
  VirtualAmendOrderPayload,
} from '../types/api/order';

const { defaultInstance } = exodusInstance;

export const getVirtualOrderList = (): Promise<
  APIResponse<VirtualTradingOrder>
> => defaultInstance.get(orderEndpoints.list());

export const postVirtualOrder = (
  orderType: 'buy' | 'sell',
  symbol: string,
  payload: VirtualCreateOrderPayload,
): Promise<APIResponse<{ order_id: string } | { order_ids: string[] }>> =>
  defaultInstance.post(orderEndpoints.create(orderType, symbol), payload);

export const postVirtualAmendOrder = (
  payload: VirtualAmendOrderPayload,
): Promise<APIResponse<VirtualAmendOrderResponse>> =>
  defaultInstance.post(orderEndpoints.amend(), payload);
